<template>
  <div id="express-list">
    <div class="material-helper">
      带 <span class="fg-red">*</span> 为必备资料
    </div>

    <div class="material-wrap">

      <!--各职业的申请人资料列表-->
      <div class="material-panel">
        <div class="material-group" v-for="(materialGroup, gpidx) in materials" :key="gpidx">
          <div class="material-left">
            <div class="material-identity">{{materialGroup.identity_id === 5 ? '通用身份': identitys[materialGroup.identity_id]}}</div>
          </div>
          <div class="material-right">
            <div class="material-names">
              <span v-for="(name, k) in materialGroup.names" :key="'gp_' + k">{{name}}<span v-if="k < materialGroup.names.length - 1">、</span></span>
            </div>

            <!--资料列表-->
            <ul class="material-list">
              <li class="material-item" v-for="(material, materialIndex) in materialGroup.materialAll" :key="'ma_' + materialIndex">
                <span class="material-item-hover">
                  {{material.name}}<span class="fg-red material-star" v-if="material.required">*</span>
                  <div class="material-item-hover-content" v-if="material.attention">
                    <span class="trangle"><em></em></span>
                  <ul v-if="material.attention" class="material-attention">
                    <li v-for="(str, k) in material.attention.split('\n')" :key="'at_' + k">{{str}}</li>
                  </ul>
                    </div>
                </span>
                <!-- <el-tooltip :disabled="!material.attention" placement="bottom-start" effect="light">
                  <div slot="content">
                    <ul v-if="material.attention" class="material-attention">
                      <li v-for="(str, k) in material.attention.split('\n')" :key="'at_' + k">{{str}}</li>
                    </ul>
                  </div>
                  <span>
                    {{material.name}}<span class="fg-red material-star" v-if="material.required">*</span>
                  </span>
                </el-tooltip> -->
                <span v-if="material.attr == 0 && material.pattern < 3">（复印件）</span>
                <span v-if="material.pattern == 3">（复印件，未婚、丧偶无需提供）</span>
                <a v-if="material.template" :href="material.template +'&response-content-type=application/octet-stream'" class="material-item-template" >模板</a>
                <a v-if="material.sample && material.sample.length > 0" @click="showImage(material.sample)" class="material-item-sample">样例</a>
                <div style="clear: both;"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <div class="material-footer">
      <div class="material-helper">
        <div class="material-warn">!</div>请确认申请人的所需资料已备齐，并在下单后尽快邮寄！
      </div>

      <div class="material-action">
        <el-checkbox :value="confirm" @input="updateConfirm">确认以上资料已备齐</el-checkbox>
        <el-button type="primary" class="common-button" @click="beforePurchase()">确定</el-button>
      </div>
    </div>

    <!-- 多图预览弹窗 -->
    <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
  </div>
</template>

<script>
import User from '../../libs/user';
import status from '../../libs/status';
import multiImagePreview from '../../components/common/multi-image-preview';

export default {
  name: 'expressList',
  components: {
    multiImagePreview,
  },
  props: {
    materials: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    confirm: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      User,
      identitys: status.identity, // 所有身份
      multiImagePreviewOpen: false,
      multiImageArray: [],
    };
  },
  methods: {
    updateConfirm(confirm) {
      MtaH5.clickStat('sendoffline0infoready');
      this.$emit('updateConfirm', confirm);
    },

    beforePurchase() {
      MtaH5.clickStat('sendoffline0confirm');
      this.$emit('beforePurchase', 1);
    },

    showImage(data) {
      this.$emit('showImage', data);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";

#express-list {
  position: absolute;
  padding: 0 36px;
  left: 0;
  top: 50px;
  right: 0;
  bottom: 0;
  z-index: 6;
  background-color: white;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  .material-helper {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #6f6f6f;
  }

  .material-attention {
    li {
      word-break: break-all;
      max-width: 380px;
      line-height: 1.5;
    }
  }

  .material-wrap {
    position: absolute;
    top: 40px;
    left: 36px;
    right: 36px;
    bottom: 100px;
  }

  .material-panel {
    background-color: #fbfbfb;
    border-radius: 3px;
    border: 1px solid #f0f0f0;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 10px;
  }

  .material-group {
    padding: 15px 12px;
    display: flex;
    position: relative;
  }

  .material-left {
    width: 100px;
  }

  .material-right {
    flex: 1;
  }

  .material-group + .material-group::before {
    content: "";
    position: absolute;
    display: block;
    border-top: 1px dashed #f0f0f0;
    top: 0;
    right: 15px;
    left: 105px;
  }

  .material-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    padding: 0 36px 0 36px;

    .material-helper {
      color: #444;
    }

    .material-warn {
      border: 1px solid @red;
      display: inline-block;
      border-radius: 50%;
      text-align: center;
      width: 15px;
      height: 15px;
      line-height: 14px;
      color: @red;
      margin-right: 8px;
    }
  }

  .material-action {
    margin-top: 5px;
    height: 38px;
    line-height: 38px;

    .el-checkbox {
      color: @main;
    }

    .el-checkbox__inner {
      border-color: @main;
    }

    .el-button {
      float: right;
      width: 140px;
      height: 38px;
      font-size: 15px;
    }
  }

  .material-names {
    color: #333;
    font-size: 14px;
    line-height: 24px;
    margin-top: -4px;
  }

  .material-identity {
    font-size: 15px;
    color: #333;
    font-weight: 500;
    border-left: 2px solid #1d96cd;
    padding-left: 5px;
  }

  .material-list {
    margin-top: 8px;
  }

  .material-item {
    line-height: 33px;
    color: #6f6f6f;
    border-bottom: 1px solid #f0f0f0;
    .material-item-hover {
      position: relative;
      .material-item-hover-content {
        position: absolute;
        display: none;
      }
      &:hover {
        .material-item-hover-content {
          z-index: 1;
          display: block;
          background: #fff;
          width: 260px;
          border: 1px solid #f0f0f0;
          border-radius: 5px;
          padding: 15px;
          .dian {
            margin-right: 5px;
          }
          .material-attention {
            li {
              line-height: 24px;
              font-size: 14px;
              position: relative;
            }
          }
          .trangle {
            display: block;
            width: 0;
            height: 0;
            border-width: 0 8px 8px;
            border-style: solid;
            border-color: transparent transparent #f0f0f0;
            position: absolute;
            top: -9px;
            left: 20px;
            // left: 50%; /* 三角形居中显示 */
            // margin-left: -10px; /* 三角形居中显示 */
          }
          em {
            display: block;
            width: 0;
            height: 0;
            border-width: 0 8px 8px;
            border-style: solid;
            border-color: transparent transparent #fff;
            position: absolute;
            top: 2px;
            left: -8px;
          }
        }
      }
    }
    &.material-item:nth-last-of-type(1) {
      border-bottom: none;
    }
    .material-star {
      padding-left: 8px;
      vertical-align: middle;
    }
    .el-tooltip {
      width: 320px;
    }
    .material-item-sample {
      float: right;
      width: 48px;
      height: 20px;
      border: 1px solid #cfcfcf;
      color: #cfcfcf;
      text-align: center;
      line-height: 18px;
      border-radius: 4px;
      margin-top: 7px;
      font-size: 12px;
      color: #777777;
    }
    .material-item-template {
      float: right;
      width: 48px;
      height: 20px;
      border: 1px solid #5e9be1;
      color: #5e9be1;
      text-align: center;
      line-height: 18px;
      border-radius: 4px;
      margin-left: 10px;
      margin-top: 7px;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/express-list.vue